export default "__VITE_ASSET__79391848__"